import * as types from "./types";
import {
    getLeaveBalanceEmployeeAxios,
    getLeaveBalanceSubordinatesAxios
} from "./services";

export async function getLeaveBalanceEmployeeAction({ commit }) {
    commit(types.LOADING_LEAVEBALANCE, true);
    try {
        const { data } = await getLeaveBalanceEmployeeAxios();
        commit(types.GET_LEAVEBALANCE_EMPLOYEE, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVEBALANCE, false);
    }
}

export async function getLeaveBalanceSubordinatesAction({ commit }) {
    commit(types.LOADING_LEAVEBALANCE, true);
    try {
        const { data } = await getLeaveBalanceSubordinatesAxios();
        commit(types.GET_LEAVEBALANCE_SUBORDINATES, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVEBALANCE, false);
    }
}